import React, { Component } from "react";
import { connect } from "react-redux";
import { actions as userActions } from "../../../../redux/modules/user";
import { NavLink } from "react-router-dom";
import "./style.css";
class MajorItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { majorCode, marjorName, level, id } = this.props;
    return (
      <NavLink
        onClick={(event) => this.handleJump(event)}
        to={"/majorintro/" + id}
        className="majorItem_box"
      >
        <div className="majorItem_box_left fl">{majorCode}</div>
        <div className="majorItem_box_middle fl ">{marjorName}</div>
        <div className="majorItem_box_right fl">{level}</div>
      </NavLink>
    );
  }
  handleJump = (event) => {
    let userInfo = this.props.userInfo;
    const { dispatch } = this.props;
    //如果没有登录 ，阻止它跳转，并且弹出登录框
    if (userInfo.isLogin === false) {
      event.preventDefault(); //阻止默认事件
      dispatch(userActions.setShowLogin(true));
    }
  };
}
const mapStateToProps = (state) => {
  return {
    userInfo: state.user.userData.userInfo,
  };
};
export default connect(mapStateToProps)(MajorItem);



// WEBPACK FOOTER //
// ./src/containers/Major/components/MajorItem/index.js